export const advertisersAdvancedFilters = {
  isEmailConfirmed: null,
  skype: null,
  telegram: null,
  whatsApp: null,
  viber: null,
  verticalId: null
};